import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/iwwtencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/iwwelegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/IRAILS/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";

const TODIS_FORM_IIWW = ({errors, touched, status}) => {
    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="remarks" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmDescDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmDescDTO.remarks" label="Remarks" name="iwwImpPmDescDTO.remarks" disabled={status}/>
                            {errors.iwwImpPmDescDTO && errors.iwwImpPmDescDTO.remarks && touched.iwwImpPmDescDTO && touched.iwwImpPmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmStatusDTO"/>
            </Tab>
            <Tab eventKey="elegibilityproject" title="TEN-T Project ">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmEligiTentDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmEligiTentDTO.remarks" label="Remarks" name="iwwImpPmEligiTentDTO.remarks" disabled={status}/>
                            {errors.iwwImpPmEligiTentDTO && errors.iwwImpPmEligiTentDTO.remarks && touched.iwwImpPmEligiTentDTO && touched.iwwImpPmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T Compliance">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmTentcompDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmTentcompDTO.remarks" label="Remarks" name="iwwImpPmTentcompDTO.remarks" disabled={status}/>
                            {errors.iwwImpPmTentcompDTO && errors.iwwImpPmTentcompDTO.remarks && touched.iwwImpPmTentcompDTO && touched.iwwImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Traffic - forecasted" Label2="Traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmPiDTO.remarks" label="Remarks" name="iwwImpPmPiDTO.remarks" disabled={status}/>
                            {errors.iwwImpPmPiDTO && errors.iwwImpPmPiDTO.remarks && touched.iwwImpPmPiDTO && touched.iwwImpPmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="indicators" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="iwwImpPmIndicatorsDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmIndicatorsDTO.remarks" label="Remarks" name="iwwImpPmIndicatorsDTO.remarks" disabled={status}/>
                            {errors.iwwImpPmIndicatorsDTO && errors.iwwImpPmIndicatorsDTO.remarks && touched.iwwImpPmIndicatorsDTO && touched.iwwImpPmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}
export default TODIS_FORM_IIWW;